import styled from '@emotion/styled'
import Link from 'next/link'
import type { PropsWithChildren } from 'react'

import { Provider as DesignSystemProvider } from '@cash-design-system/react'
import { Header } from '@cash-web/support/ui-components'
import { Footer } from '@cash-web/support/ui-components'

const GlobalContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-flow: column;
`

const BodyContainer = styled.div`
  background-color: ${props => props.theme.colors.behindBackground};
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
`

const Layout = ({ children }: PropsWithChildren) => {
  return (
    <DesignSystemProvider darkMode={false}>
      <GlobalContainer>
        <Header Link={Link} linkProps={{ href: '/' }} />
        <BodyContainer>{children}</BodyContainer>
        <Footer Link={Link} linkProps={{ href: '/' }} />
      </GlobalContainer>
    </DesignSystemProvider>
  )
}

export default Layout
